export default __webpack_public_path__ + "static/media/2.b4e50330.PNG";